import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';
import getDisplayName from '../utils/get-display-name';
var ZIndexStackContext = createContext({});
/**
 * Функция, задающая контекс zIndex
 * 1. Достаем значение zIndex в стеке
 * 2. Прибавляем к нему zIndex и пробрасываем его как props
 * 3. Сохраняем новый zIndex в context
 */

export default function zIndexStack(initialZIndex) {
  return function (Target) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      _inherits(_class, _Component);

      var _super = _createSuper(_class);

      function _class() {
        var _this;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));
        _this.zIndex = (_this.context.ruiZIndex || 0) + _this.props.zIndex;
        return _this;
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return React.createElement(ZIndexStackContext.Provider, {
            value: this.contextValue
          }, React.createElement(Target, _extends({}, this.props, {
            zIndex: this.zIndex
          })));
        }
      }, {
        key: "contextValue",
        get: function get() {
          return {
            ruiZIndex: this.zIndex
          };
        }
      }]);

      return _class;
    }(Component), _class.displayName = "zIndexStack(".concat(getDisplayName(Target), ")"), _class.propTypes = {
      zIndex: PropTypes.number
    }, _class.defaultProps = {
      zIndex: initialZIndex
    }, _class.contextType = ZIndexStackContext, _temp;
  };
}